import React from 'react'
import { motion } from 'framer-motion'

import './loading.scss'

export const Loading = () => {
  return (
    <div className="loading-container">
      <motion.div
        className="loading-animation"
        style={{
          display: 'inline-block',
          borderRadius: '50%',
          border: '3px solid #eee',
          borderTop: '3px solid #21205e'
        }}
        animate={{ rotate: 360 }}
        transition={{
          repeat: Infinity,
          loop: Infinity,
          ease: 'linear',
          duration: 1
        }}
      />
    </div>
  )
}
